import { type EmergencyCodeEnum } from '@/common/types/emergencies'

/**
 * Possible bulk actions for cases
 */

export enum BulkActionEnum {
  TICKETS_BULK_CANCEL = 'TICKETS_BULK_CANCEL',
  TICKETS_BULK_UNASSIGN = 'TICKETS_BULK_UNASSIGN',
  TICKETS_BULK_COMPLETE = 'TICKETS_BULK_COMPLETE',
  TICKETS_BULK_REOPEN = 'TICKETS_BULK_REOPEN',
  TICKETS_BULK_ASSIGN = 'TICKETS_BULK_ASSIGN',
  TICKETS_BULK_REASSIGN = 'TICKETS_BULK_REASSIGN',
  TICKETS_BULK_REASSIGN_ON_VALIDATION = 'TICKETS_BULK_REASSIGN_ON_VALIDATION',
  TICKETS_BULK_TRANSFER = 'TICKETS_BULK_TRANSFER',
  TICKETS_BULK_TRANSFER_ON_VALIDATION = 'TICKETS_BULK_TRANSFER_ON_VALIDATION',
  TICKETS_BULK_HANDLE_INTERACTIONS = 'TICKETS_BULK_HANDLE_INTERACTIONS',
  TICKETS_BULK_ESCALATE = 'TICKETS_BULK_ESCALATE',
  TICKETS_BULK_CATEGORIZE = 'TICKETS_BULK_CATEGORIZE',
  TICKETS_BULK_ATTACHPARENT = 'TICKETS_BULK_ATTACHPARENT',
}

export interface BaseBulkActionDTOV1 {
  ids: number[]
  checkLock?: boolean
  comment?: string
}

export interface ReasonBulkActionDTOV1 extends BaseBulkActionDTOV1 {
  reasonCode?: string
}

export interface AssignBulkActionDTOV1 extends BaseBulkActionDTOV1 {
  userLogin: string
}

export interface TransferBulkActionDTOV1 extends BaseBulkActionDTOV1 {
  reasonCode?: string
  skillCode: string
  userLogin?: string
}

export interface HandleInteractionsBulkActionDTOV1 extends BaseBulkActionDTOV1 {
  reasonCode?: string
  completeCases?: boolean
}

export interface EscalateBulkActionDTOV1 extends BaseBulkActionDTOV1 {
  emergencyCode: EmergencyCodeEnum
}

export interface CategorizeBulkActionDTOV1 extends Omit<BaseBulkActionDTOV1, 'comment'> {
  contactDriverCode: string
}

export interface AttachParentBulkActionDTOV1 extends Omit<BaseBulkActionDTOV1, 'comment' | 'checkLock'> {
  ids: number[]
  parentId: number
}
